<template>
  <el-drawer
    :title="$l('INDEX.evg_sku_label_edit_artwork') || '编辑图稿'"
    :visible.sync="drawerVisible"
    direction="rtl"
    :size="750"
    :beforeClose="handleBeforeClose"
    @close="onClose"
    append-to-body
  >
    <ArtworkForm
      :evgSkuMaterialCode="evgSkuMaterialCode"
      :evgSkuCode="evgSkuCode"
    />
  </el-drawer>
</template>
<script>
import ArtworkForm from './ArtworkForm.vue'
export default {
  components: {
    ArtworkForm
  },
  props: {
    visible: Boolean,
    evgSkuMaterialCode: String,
    evgSkuCode: String
  },
  data () {
    return {
      drawerVisible: false
    }
  },
  watch: {
    drawerVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  created () {
    this.drawerVisible = this.visible
  },
  methods: {
    handleBeforeClose (done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>
